import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  modalPrimaryButtonStyle
} from '../styles/buttonStyles'
const MFAPromptModal = ({ open, onEnable, onClose }) => {
  const { t } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation()
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#122629',
          padding: 20,
          border: '2px solid #107c6b',
          borderRadius: 12,
          boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
          width: 'clamp(320px, 30vw, 460px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            width: '100%',
            alignItems: 'center',
            marginBottom: 24,
            textAlign: 'center'
          }}
        >
          <p
            style={{
              fontSize: 22,
              margin: 0,
              color: '#d9ffe4',
              fontWeight: 600
            }}
          >
            {t('MFA_RECOMMENDED')}
          </p>

          <p
            style={{
              fontSize: 16,
              margin: 0,
              color: 'rgba(217,255,228,0.8)'
            }}
          >
            {t('MFA_RECOMMENDED_TEXT')}
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            gap: 12
          }}
        >
          <button
            style={modalPrimaryButtonStyle(
              pressedBtn,
              'enable',
              hoverBtn === 'enable'
            )}
            onMouseEnter={() => setHoverBtn('enable')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('enable')}
            onMouseUp={() => setPressedBtn(null)}
            onClick={onEnable}
          >
            {t('ENABLE_MFA')}
          </button>

          <button
            style={modalPrimaryButtonStyle(
              pressedBtn,
              'later',
              hoverBtn === 'later'
            )}
            onMouseEnter={() => setHoverBtn('later')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('later')}
            onMouseUp={() => setPressedBtn(null)}
            onClick={onClose}
          >
            {t('LATER')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default MFAPromptModal